























import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Period from "@/models/annoucement/period.Model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from "@/enums/PermissionValue";
import Audit from "../../models/security/audit.model";
@Component
export default class TableAuditComponent extends GenericBTable<Audit> {
  created() {
    this.permissionValue = PermissionValue.AUDITORIA;
    this.tableConfig.controller = "Audit";
    this.formatColumns();
  }
  formatColumns() {
    let description = new BTableColumn(
      "description",
      "table.description",
      true
    );
    let userName = new BTableColumn("userName", "table.userName", true);
    let ip = new BTableColumn("ip", "table.ip", true);
    this.tableConfig.insertColumns(description, userName, ip);
    this.tableConfig.enableDefaultColumns = true;

    description.customTemplate = true;
    userName.customTemplate = true;

    this.tableConfig.activeActions = false;
  }
}
